export default __webpack_public_path__ + "check_mark.3f6a0852.svg";